import { Text, Bar, BarChart as MuiBarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts'

const renderCustomizedAxisTick = ({ payload, x, y }) => (
  <Text
    x={x}
    y={y + 10}
    width={90}
    textAnchor="middle"
    fill="#2D2D6C"
    verticalAnchor="start"
    maxLines={2}
    breakAll
    style={{ fontSize: 12 }}
  >
    {payload.value}
  </Text>
)

const BarChart = ({ dataKey, maxValue, ...props }) => (
  <ResponsiveContainer width="100%" height={250}>
    <MuiBarChart width="100%" height="100%" {...props}>
      <YAxis allowDecimals={false} domain={maxValue ? [0, maxValue] : ['auto', 'auto']} />
      <XAxis dataKey="name" height={50} tick={renderCustomizedAxisTick} />
      <Bar dataKey={dataKey} maxBarSize={30} />
    </MuiBarChart>
  </ResponsiveContainer>
)

export default BarChart
